import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Login from "./login";
import SearchDev from "./searchDev";
import EditDevData from "./editDevData";

const router = createBrowserRouter([
  
  {
    path: "/",
    element: <Login />,
  },
  {
    path:"/searchdev",
    element:<SearchDev />,
  },
  {
    path:"/editdevdata",
    element:<EditDevData />,
  }
]);

function App() {
  return  (<RouterProvider router={router} />);
}

export default App;